import { memo } from 'react';

import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import { FocusGrid, ContainerGrid, ActionTwoButtonsGrid } from '#client/components/Grid';

import { DialogContentStyled, Wrapper } from './CheckDepositSubmissionOverview.styles';
import Note from './components/Note';
import OverviewTitle from './components/OverviewTitle';
import Summary from './components/SummaryInfos';
import SummaryMoney from './components/SummaryMoney';

const CheckDepositSubmissionOverview = ({ amount, handleClose, handleDepositAnother }) => {
  const closeHandler = () => {
    handleClose();
  };

  const depositAnotherHandler = () => {
    handleDepositAnother();
  };

  return (
    <Stack
      height="100%"
      mx="16px"
    >
      <DialogContentStyled>
        <ContainerGrid padding={0}>
          <FocusGrid>
            <Wrapper>
              <OverviewTitle />
              <Stack gap="16px">
                <SummaryMoney
                  amount={amount}
                  type="processing"
                />
                <Summary />
                <Note />
              </Stack>
            </Wrapper>
          </FocusGrid>
        </ContainerGrid>
      </DialogContentStyled>
      <ActionTwoButtonsGrid
        firstButton={
          <Button
            aria-label="deposit another"
            disableRipple
            fullWidth
            onClick={depositAnotherHandler}
            size="large"
            variant="outlined"
          >
            Deposit another
          </Button>
        }
        secondButton={
          <Button
            aria-label="finish and close"
            disableRipple
            fullWidth
            onClick={closeHandler}
            size="large"
            variant="contained"
          >
            Finish and close
          </Button>
        }
      />
    </Stack>
  );
};

CheckDepositSubmissionOverview.propTypes = {
  amount: PropTypes.number.isRequired,
  handleDepositAnother: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired
};

export default memo(CheckDepositSubmissionOverview);
